import { HTTPStatusCode } from "@libs/api/types";
import {
  ListRedeterminationsFilterType,
  UpdateRedeterminationType,
} from "@/domain/redeterminations";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const RedeterminationsApi = {
  listRedeterminations: async (body: ListRedeterminationsFilterType) => {
    const res = await tsRestClient().redeterminations.listRedeterminations({
      query: body,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to list redeterminations",
    });
  },
  getRedetermination: async (redeterminationId: string) => {
    const res = await tsRestClient().redeterminations.getRedetermination({
      params: { redeterminationId },
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Failed to get redetermination",
      shouldThrowError: true,
    });
  },
  updateRedetermination: async (
    id: string,
    params: UpdateRedeterminationType,
  ) => {
    const res = await tsRestClient().redeterminations.updateRedetermination({
      params: { id },
      body: params,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message: "Failed to update redetermination",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
